import type { childPartV1, childPartV2 } from "@/api/breakdownService";
import { TableCell } from "@mui/material";

interface ChildPartInfoDataProps {
  row: childPartV1 | childPartV2;
}

interface ChildPartV1PriceProps {
  row: childPartV1;
}

const ChildPartV1Price = ({ row }: ChildPartV1PriceProps) => {
  return (
    <>
      <TableCell
        sx={{
          minWidth: 100,
          maxWidth: 100,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.oem_price ?? 0).toFixed(2)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 100,
          maxWidth: 100,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.spare_price ?? 0).toFixed(2)}
      </TableCell>
    </>
  );
};

const ChildPartInfoData = ({ row }: ChildPartInfoDataProps) => {
  const isV1 = "oem_price" in row && "spare_price" in row;

  return (
    <>
      {isV1 && <ChildPartV1Price row={row as childPartV1} />}
      <TableCell
        sx={{
          minWidth: 80,
          maxWidth: 80,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {row.child_part_info.qty}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 300,
          maxWidth: 300,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          wordBreak: "break-word",
        }}
      >
        {row.child_part_info.material_code}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_info.material_price ?? 0).toFixed(2)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 100,
          maxWidth: 100,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {row.child_part_info.amount}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_info.ratio ?? 0).toFixed(2)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_info.consumption ?? 0).toFixed(3)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_info.part_weight ?? 0).toFixed(3)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_info.scrap_weight ?? 0).toFixed(3)}
      </TableCell>
    </>
  );
};

export default ChildPartInfoData;
